import { render, staticRenderFns } from "./FileUploaderMini.vue?vue&type=template&id=37fef9e1"
import script from "./FileUploaderMini.vue?vue&type=script&lang=js"
export * from "./FileUploaderMini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports